module.exports = __webpack_public_path__ + "img/Ventla-Logo-White.f440ae7c.svg";